<template>
  <v-container fluid>
    <v-card class="elevation-10">
      <v-skeleton-loader
        :loading="loading"
        type="table-heading, table-thead, table-row-divider@12, table-tfoot"
      >
        <v-card-actions>
          <v-row>
            <v-col
              cols="4"
              md="3"
              xl="4"
            >
              <v-toolbar
                flat
              >
                <v-toolbar-title class="md-4 white--text">
                  Fund Bucket Item Description
                </v-toolbar-title>
              </v-toolbar>
            </v-col>
            <v-col
              cols="4"
              md="3"
              xl="4"
            >
              <v-text-field
                v-model="search"
                placeholder="Search"
                append-icon="fa fa-search"
                label="Search Fund Bucket Item Description"
                hide-no-data
                hide-selected
                clearable
              />
            </v-col>
            <v-col
              cols="1"
              md="3"
              xl="1"
            />
            <v-col
              cols="3"
              md="3"
              xl="3"
              class="mt-2 text-right"
            >
              <bucket-fund-bucket-item-description-dialog-create
                @created="loadData"
              />
            </v-col>
          </v-row>
        </v-card-actions>

        <v-data-table
          dense
          :headers="headers"
          :items="fundBucketItemDescriptions"
          :items-per-page="15"
          class="scrollable-table elevation-10"
          :search="search"
          data-simplebar
        >
          <template v-slot:[`item.company`]="{ item }">
            <div>
              <span>
                {{ item.name }}
              </span>
            </div>
          </template>

          <template v-slot:[`item.action`]="{ item }">
            <bucket-fund-bucket-item-description-dialog-edit
              :fund-bucket-item-description="item"
              @updated="loadData"
            />
            <span class="mx-1" />
            <bucket-fund-bucket-item-description-dialog-delete
              :fund-bucket-item-description="item"
              @deleted="loadData"
            />
          </template>
        </v-data-table>
      </v-skeleton-loader>
    </v-card>
  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        loading: true,
        search: '',
        snackColor: '',
        snack: '',
        snackText: '',
        headers: [
          { text: 'Description', value: 'description' },
          { text: 'Action', value: 'action', align: 'center', class: 'md-2', sortable: false },
        ],

        fundBucketItemDescriptions: [],
      }
    },

    created () {
      this.loadData()
    },

    methods: {
      loadData () {
        this.$api.fundBucketItemDescriptions().list()
          .then(response => {
            this.fundBucketItemDescriptions = response.data
            this.loading = false
          })
          .catch(err => {
            console.log(err)
          })
      },
    },
  }
</script>

<style scoped>
    .center-snackbar .v-snack__wrapper .v-snack__content{
        margin:auto !important;
        width:unset !important;
    }
</style>
